
import { VerificacionTipoDocumentoAdquiriente, CalcularDigitoVerificacion } from '../../../Utils/ElectronicInvoice';

//DATA
const ADQTags = (doc, data, clinica, IVA, typeDocumentInvoice) => {
    var ADQ = doc.createElement("ADQ");

    console.log("dataInvoice", data);

    //Determinacion de Tipo de Facturado (1 Juridico, 2 Natural)
    var ADQ_1 = doc.createElement("ADQ_1");
    ADQ_1.innerHTML = data.detalles_comerciales.cliente.type_document != "NIT" ? 2 : 1;
    ADQ.appendChild(ADQ_1);

    //Determinacion de Tipo de Facturado (1 Juridico, 2 Natural)
    var ADQ_2 = doc.createElement("ADQ_2");
    ADQ_2.innerHTML = data.detalles_comerciales.cliente.type_document != "NIT" ? data.detalles_comerciales.cliente.num_document : data.detalles_comerciales.cliente.num_document.split("-")[0];
    ADQ.appendChild(ADQ_2);

    //Determinacion de Tipo de Facturado (1 Juridico, 2 Natural)
    var ADQ_3 = doc.createElement("ADQ_3");
    ADQ_3.innerHTML = VerificacionTipoDocumentoAdquiriente(data.detalles_comerciales.cliente.tipo_documento);
    ADQ.appendChild(ADQ_3);

    //Codigo Grava con IVA
    var ADQ_4 = doc.createElement("ADQ_4");
    ADQ_4.innerHTML = IVA == true ? 49 : "";
    ADQ.appendChild(ADQ_4);

    //Nombre Completo del Adquiriente (Paciente) o RUT de la Empresa (Nombre de la Empresa)
    var ADQ_6 = doc.createElement("ADQ_6");
    ADQ_6.innerHTML = data.detalles_comerciales.cliente.name;
    ADQ.appendChild(ADQ_6);

    //Nombre COMERCIAL del Adquiriente (Paciente) o RUT de la Empresa (Nombre de la Empresa)
    var ADQ_7 = doc.createElement("ADQ_7");
    ADQ_7.innerHTML = data.detalles_comerciales.cliente.name;
    ADQ.appendChild(ADQ_7);

    //Si es un PACIENTE particular
    if (data.detalles_comerciales.cliente.type_document != "NIT") {

        //Nombre del Paciente
        var ADQ_8 = doc.createElement("ADQ_8");
        ADQ_8.innerHTML = data.detalles_comerciales.cliente.nombre_aquiriente;
        ADQ.appendChild(ADQ_8);

        //Apellido del Paciente
        var ADQ_9 = doc.createElement("ADQ_9");
        ADQ_9.innerHTML = data.detalles_comerciales.cliente.apellido1_adquiriente + " " + data.detalles_comerciales.cliente.apellido2_adquiriente;
        ADQ.appendChild(ADQ_9);
    }

    //Direccion del Adquiriente
    var ADQ_10 = doc.createElement("ADQ_10");
    ADQ_10.innerHTML = data.detalles_comerciales.cliente.adress;
    ADQ.appendChild(ADQ_10);

    //Departamento del Adquiriente
    var ADQ_11 = doc.createElement("ADQ_11");
    ADQ_11.innerHTML = data.detalles_comerciales.cliente.departament;
    ADQ.appendChild(ADQ_11);

    //Campo Vacio (Por actualizacion de la DIAN en version UBL 2.1)
    var ADQ_12 = doc.createElement("ADQ_12");
    ADQ_12.innerHTML = "";
    ADQ.appendChild(ADQ_12);

    //Nombre de la Ciudad
    var ADQ_13 = doc.createElement("ADQ_13");
    ADQ_13.innerHTML = data.detalles_comerciales.cliente.city_name;
    ADQ.appendChild(ADQ_13);

    //Codigo Postal del Adquiriente (ESTA QUEMADO, HAY QUE CAMBIARLO!!!)
    var ADQ_14 = doc.createElement("ADQ_14");
    ADQ_14.innerHTML = clinica.codigo_postal; //codigo postal
    ADQ.appendChild(ADQ_14);

    //Codigo del Pais
    var ADQ_15 = doc.createElement("ADQ_15");
    ADQ_15.innerHTML = "CO"; //codigo postal
    ADQ.appendChild(ADQ_15);

    //Departamento Nombre
    var ADQ_19 = doc.createElement("ADQ_19");
    ADQ_19.innerHTML = data.detalles_comerciales.cliente.dep_name;
    ADQ.appendChild(ADQ_19);

    //Nombre del Pais
    var ADQ_21 = doc.createElement("ADQ_21");
    ADQ_21.innerHTML = "Colombia";
    ADQ.appendChild(ADQ_21);

    //Digito de Verificacion del Adquiriente -DV
    var ADQ_22 = doc.createElement("ADQ_22");
    ADQ_22.innerHTML = data.detalles_comerciales.cliente.type_document != "NIT" ? CalcularDigitoVerificacion(data.detalles_comerciales.cliente.num_document) : CalcularDigitoVerificacion(data.detalles_comerciales.cliente.num_document.split("-")[0]);
    ADQ.appendChild(ADQ_22);

    //Codigo del Municipio del Adquiriente
    var ADQ_23 = doc.createElement("ADQ_23");
    ADQ_23.innerHTML = data.detalles_comerciales.cliente.city;
    ADQ.appendChild(ADQ_23);

    //Numero del Consumidor
    var ADQ_24 = doc.createElement("ADQ_24");
    ADQ_24.innerHTML = data.detalles_comerciales.cliente.type_document != "NIT" ? "2222222222" : data.detalles_comerciales.cliente.num_document.split("-")[0];
    ADQ.appendChild(ADQ_24);

    ADQ.appendChild(TCRTags(doc, data, clinica));
    ADQ.appendChild(ILATags(doc, data, clinica));
    ADQ.appendChild(DFATags(doc, data, clinica));
    ADQ.appendChild(ICRTags(doc, data, clinica));
    ADQ.appendChild(GTATags(doc, data, clinica, IVA));
    ADQ.appendChild(CDATags(doc, data, clinica));

    return ADQ;
}

const TCRTags = (doc, data, clinica) => {
    var TCR = doc.createElement("TCR");

    //Responsabilidad Tributaria del Adquiriente
    var TCR_1 = doc.createElement("TCR_1");
    TCR_1.innerHTML = data.detalles_comerciales.cliente.type_document != "NIT" ? "R-99-PN" : "O-13";
    TCR.appendChild(TCR_1);

    return TCR;
}

const ILATags = (doc, data, clinica) => {
    var ILA = doc.createElement("ILA");

    //Nombre del Cliente o del Paciente
    var ILA_1 = doc.createElement("ILA_1");
    ILA_1.innerHTML = data.detalles_comerciales.cliente.name;
    ILA.appendChild(ILA_1);

    //Identificacion del Cliente
    var ILA_2 = doc.createElement("ILA_2");
    ILA_2.innerHTML = data.detalles_comerciales.cliente.num_document;
    ILA.appendChild(ILA_2);

    //Codigo del Tipo de Documento del Adquiriente
    var ILA_3 = doc.createElement("ILA_3");
    ILA_3.innerHTML = VerificacionTipoDocumentoAdquiriente(data.detalles_comerciales.cliente.type_document);
    ILA.appendChild(ILA_3);

    //Digito de Verificacion -DV del Adquiriente
    var ILA_4 = doc.createElement("ILA_4");
    ILA_4.innerHTML = data.detalles_comerciales.cliente.type_document != "NIT" ? CalcularDigitoVerificacion(data.detalles_comerciales.cliente.num_document) : CalcularDigitoVerificacion(data.detalles_comerciales.cliente.num_document.split("-")[0]);
    ILA.appendChild(ILA_4);

    return ILA;
}

const DFATags = (doc, data, clinica) => {
    var DFA = doc.createElement("DFA");

    //Codigo ALFA del Pais
    var DFA_1 = doc.createElement("DFA_1");
    DFA_1.innerHTML = "CO";
    DFA.appendChild(DFA_1);

    //Codigo del Departamento del Adquiriente
    var DFA_2 = doc.createElement("DFA_2");
    DFA_2.innerHTML = data.detalles_comerciales.cliente.departament;
    DFA.appendChild(DFA_2);

    //Codigo del Departamento del Adquiriente
    var DFA_3 = doc.createElement("DFA_3");
    DFA_3.innerHTML = clinica.codigo_postal;
    DFA.appendChild(DFA_3);

    //Codigo de la Ciudad del Adquiriente
    var DFA_4 = doc.createElement("DFA_4");
    DFA_4.innerHTML = data.detalles_comerciales.cliente.city;
    DFA.appendChild(DFA_4);

    //Nombre del Pais
    var DFA_5 = doc.createElement("DFA_5");
    DFA_5.innerHTML = "Colombia";
    DFA.appendChild(DFA_5);

    //Nombre del Departamento
    var DFA_6 = doc.createElement("DFA_6");
    DFA_6.innerHTML = data.detalles_comerciales.cliente.dep_name;
    DFA.appendChild(DFA_6);

    //Nombre de la Ciudad
    var DFA_7 = doc.createElement("DFA_7");
    DFA_7.innerHTML = data.detalles_comerciales.cliente.city_name;
    DFA.appendChild(DFA_7);

    //Direccion
    var DFA_8 = doc.createElement("DFA_8");
    DFA_8.innerHTML = data.detalles_comerciales.cliente.adress;
    DFA.appendChild(DFA_8);

    return DFA;
}

const ICRTags = (doc, data, clinica) => {
    var ICR = doc.createElement("ICR");

    //Número de Matricula Mercantil
    var ICR_1 = doc.createElement("ICR_1");
    ICR_1.innerHTML = data.detalles_comerciales.cliente.type_document == "NIT" ? data.detalles_comerciales.cliente.num_document.split("-")[0] : "";
    ICR.appendChild(ICR_1);

    return ICR;
}

const GTATags = (doc, data, clinica, IVA) => {
    var GTA = doc.createElement("GTA");

    //Declaracion de IVA
    var GTA_1 = doc.createElement("GTA_1");
    GTA_1.innerHTML = IVA == true ? "01" : "ZZ";
    GTA.appendChild(GTA_1);

    //Responsable de IVA del Comerciante
    var GTA_2 = doc.createElement("GTA_2");
    GTA_2.innerHTML = IVA == true ? "IVA" : "No Aplica";
    GTA.appendChild(GTA_2);

    return GTA;
}

const CDATags = (doc, data, clinica) => {
    var CDA = doc.createElement("CDA");

    //Tipo de Contacto del Adquiriente
    var CDA_1 = doc.createElement("CDA_1");
    CDA_1.innerHTML = 1;
    CDA.appendChild(CDA_1);

    //Nombre del Representante Legal o Persona de Contacto
    var CDA_2 = doc.createElement("CDA_2");
    CDA_2.innerHTML = data.detalles_comerciales.cliente.name;
    CDA.appendChild(CDA_2);

    //Telefono del Adquiriente
    var CDA_3 = doc.createElement("CDA_3");
    CDA_3.innerHTML = data.detalles_comerciales.cliente.phone;
    CDA.appendChild(CDA_3);

    //Correo
    var CDA_4 = doc.createElement("CDA_4");
    CDA_4.innerHTML = data.detalles_comerciales.cliente.email;
    CDA.appendChild(CDA_4);

    return CDA;
}

export default ADQTags;